/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon20Regular = forwardRef('AttachLinkOffIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.53 1.47a.75.75 0 0 0-1.06 1.06l16 16a.75.75 0 1 0 1.06-1.06l-2.208-2.208A5.751 5.751 0 0 0 14 4.25h-1.75a.75.75 0 0 0 0 1.5H14a4.25 4.25 0 0 1 1.152 8.342l-3.341-3.342H14a.75.75 0 0 0 0-1.5h-3.69l-3.5-3.5h.94a.75.75 0 0 0 0-1.5H6c-.22 0-.438.012-.653.037L2.53 1.47Z" }),
        React.createElement("path", { d: "M2.238 5.652A5.75 5.75 0 0 0 6 15.75h1.75a.75.75 0 0 0 0-1.5H6a4.25 4.25 0 0 1-2.698-7.534L2.238 5.652Z" }),
        React.createElement("path", { d: "M5.836 9.25H5.5a.75.75 0 0 0 0 1.5h1.836l-1.5-1.5Z" })));
});
